import { Navigate } from "react-router-dom";
import { useAuth } from "context/AuthContextProvider";
import PATHS from "shared/constants/paths";
import { isSystemAdmin as checkIsSystemAdmin } from "shared/utils/role";

// System admins have no dashboard (it is business-scoped). Send them to the
// business list, everyone else to the dashboard.
const HomeRedirect = () => {
  const { state } = useAuth();
  const isSystemAdmin = checkIsSystemAdmin(state.user?.roles);
  return <Navigate to={isSystemAdmin ? PATHS.BUSINESS : PATHS.DASHBOARD} replace />;
};

export default HomeRedirect;
